import React from 'react';
import { Link } from '../../atoms/Link';
import { Image } from '../../atoms/Image';

export interface CartButtonProps {
  /**
   * Cart/basket URL
   */
  href: string;
  /**
   * Cart icon image URL
   */
  icon: string;
  /**
   * Icon alt text
   */
  iconAlt?: string;
  /**
   * HTML title attribute
   */
  title?: string;
  /**
   * Click event handler
   */
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  /**
   * Custom CSS classes
   */
  className?: string;
}

export const CartButton: React.FC<CartButtonProps> = ({
  href,
  icon,
  iconAlt = 'Shopping cart',
  title = 'View shopping cart',
  onClick,
  className = '',
}) => {
  const baseClass = 'hi-ui hi-ui-cart-button';
  const allClasses = `${baseClass} ${className}`.trim();

  return (
    <div className={allClasses}>
      <Link
        href={href}
        title={title}
        onClick={onClick}
        className="hi-ui-cart-button-link"
        noUnderline
      >
        <Image
          src={icon}
          alt={iconAlt}
          width={205}
          height={30}
          loading="eager"
          className="hi-ui-cart-button-icon"
        />
      </Link>
    </div>
  );
};
